// İSG uzmanı portalı — İş İzni Tipleri (Permit Types) TanStack Query anahtarları (api-contract
// §22, tenant-scoped). Liste anahtarı parametreleri içerir (filtre/sayfa değişince yeniden çeker);
// invalidasyon önek (prefix) ile yapılır: `['permit-types','list']` tüm liste sorgularını,
// `['permit-types','detail',uuid]` bir tipin detayını (istenen belgelerle) kapsar.
//
// İş İzni (§14 `permitsKeys`) anahtarlarından AYRIDIR — tip, izinlerin sınıflamasıdır (ayrı modül
// `permit-types`); ama tip mutasyonu izin form/liste seçicilerini de etkileyebileceğinden ekranlar
// gerekiyorsa `permitsKeys` ile birlikte invalide eder.

import type { PermitTypeListParams } from '@isgportal/shared';

export const permitTypesKeys = {
  /** Tüm tip sorgularının kök öneki — invalidasyon için. */
  all: () => ['permit-types'] as const,
  /** Tüm liste sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  list: () => ['permit-types', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: PermitTypeListParams) => ['permit-types', 'list', params] as const,
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['permit-types', 'access'] as const,
  /** Tek tip detayı (istenen belge listesiyle). */
  detail: (uuid: string) => ['permit-types', 'detail', uuid] as const,
  /** İzin formundaki tip seçici için aktif tipler (tek sayfa). */
  options: () => ['permit-types', 'options'] as const,
} as const;
